import { CartProduct } from '../../../../../shared/components/FuncationsCartAndWishlist/Dto/AddToCardtUtilityDto';

import { CategoryTimeLimit } from '../dto/cart-config.dto';



export interface CategoryTimeLimitInfo {

  categoryId: string;

  message: string;

}



/**

 * Get the category time limit info for categories present in cart

 */

export function getCartCategoryTimeLimit(

  cartItems: CartProduct[],

  categoryTimeLimits?: CategoryTimeLimit[]

): CategoryTimeLimitInfo | null {

  console.log('=== Category Time Limit Debug ===');

  console.log('Cart items:', cartItems);

  console.log('Category time limits:', categoryTimeLimits);

  

  if (!cartItems || cartItems.length === 0 || !categoryTimeLimits || categoryTimeLimits.length === 0) {

    console.log('Returning null - missing data');

    return null;

  }



  // Get unique categories from cart items

  const cartCategoryIds = new Set(

    cartItems

      .map(item => item.categoryId)

      .filter(id => id)

  );



  console.log('Cart category IDs:', Array.from(cartCategoryIds));



  if (cartCategoryIds.size === 0) {

    console.log('Returning null - no category IDs in cart');

    return null;

  }



  // Find active category time limits that match items in cart

  const matchingLimits = categoryTimeLimits.filter(

    limit => limit.isActive && cartCategoryIds.has(limit.categoryId)

  );



  console.log('Matching limits:', matchingLimits);



  if (matchingLimits.length === 0) {

    console.log('Returning null - no matching limits');

    return null;

  }



  // Return the first matching limit

  const limit = matchingLimits[0];



  console.log('Returning limit:', limit);



  return {

    categoryId: limit.categoryId,

    message: limit.message,

  };

}

